import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-end fs-13 flex-shrink-0 mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "flex-fill d-flex align-items-center justify-content-center text-muted fs-13 text-center px-3"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { ref: "canvas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (option, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: option.view
        }, [
          (index > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "|"))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: "javascript:",
            class: _normalizeClass(["period-option px-1", {active: option.view === _ctx.view}]),
            onClick: ($event: any) => (_ctx.switchTo(option.view))
          }, _toDisplayString(option.label), 11, _hoisted_4)
        ], 64))
      }), 128))
    ]),
    (_ctx.isEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.emptyMessage) + " ", 1),
            (_ctx.fillInUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.fillInUrl,
                  class: "fw-semibold"
                }, "Doplnit údaje", 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "flex-fill",
      style: _normalizeStyle({minHeight: _ctx.height + 'px'})
    }, [
      _createElementVNode("canvas", _hoisted_7, null, 512)
    ], 4), [
      [_vShow, !_ctx.isEmpty]
    ])
  ]))
}